import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@mui/material";

import { partiesListQueryOptions } from "@/lib/queries";
import { PartiesGrid, countLabel } from "@/grids/PartiesGrid";
import { PartyDialog } from "@/components/PartyDialog";
import { useShortcut } from "@/lib/shortcuts";

export const Route = createFileRoute("/_auth/customers/")({
  component: CustomersListPage,
});

function CustomersListPage() {
  const customers = useQuery(partiesListQueryOptions({ party_type: "customer" }));
  const [createOpen, setCreateOpen] = useState(false);
  // Rows the grid shows after its search/filters; null until the grid reports.
  const [shown, setShown] = useState<number | null>(null);

  useShortcut("n", () => setCreateOpen(true), {
    label: "New customer",
  });

  return (
    <div className="flex flex-col h-[calc(100vh-56px)] overflow-hidden">
      <div className="bg-white border-b border-slate-200 dark:bg-gray-900 dark:border-gray-800 px-6 py-3">
        <div className="flex items-center gap-3">
          <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100">Customers</h1>
          <span className="text-xs text-slate-500 dark:text-slate-400">
            {countLabel(customers.data?.length ?? 0, shown)} · click a code to open the customer
          </span>
          <div className="flex-1" />
          <Link
            to="/vendors"
            className="text-sm text-slate-500 hover:text-slate-900 underline dark:text-slate-400 dark:hover:text-slate-100"
          >
            view vendors →
          </Link>
          <Button
            variant="contained"
            size="small"
            onClick={() => setCreateOpen(true)}
          >
            + New customer
          </Button>
        </div>
      </div>

      <div className="flex-1 px-6 py-4 overflow-hidden">
        {customers.isLoading && (
          <div className="text-sm text-slate-500 dark:text-slate-400">Loading customers…</div>
        )}
        {customers.error && (
          <div className="text-sm text-red-600">
            Error: {(customers.error as Error).message}
          </div>
        )}
        {customers.data && (
          <PartiesGrid parties={customers.data} partyType="customer" onShownCountChange={setShown} />
        )}
      </div>

      <PartyDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        partyType="customer"
      />
    </div>
  );
}
